import React from 'react';
import DocumentTitle from 'react-document-title';
import 'react-table/react-table.css';
import ReactTable from 'react-table';

import {getVendor, getSettings, getReservationsByVendorId} from '../data/get-from-sheet';

import Loading from './Loading';
import LabelValuePair from './LabelValuePair';

class SummaryPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            sheetId: props.match.params.sheetId,
            vendorId: props.match.params.vendorId
        };
    }

    async componentDidMount() {
        const vendorPromise = getVendor(this.state.sheetId, this.state.vendorId);
        const settingsPromise = getSettings(this.state.sheetId);
        const reservationsPromise = getReservationsByVendorId(this.state.sheetId, this.state.vendorId);
        const [settings, vendor, reservations] = await Promise.all([settingsPromise, vendorPromise, reservationsPromise]);

        this.setState(() => ({
            loading: false,
            reservations,
            settings,
            vendor
        }));
    }

    render() {
        const details = this.state.settings;

        return this.state.loading
            ? <Loading />
            : (
                <DocumentTitle title={`${details.window.title} - ${this.state.vendor.name}`}>
                    <main>
                        <h6 className="hy-vee-red">{`${this.state.vendor.name}: ${this.state.reservations.length} of ${this.state.vendor.allowedReservationCount}`}</h6>
                        <p>{details.summary.usage}</p>
                        <LabelValuePair
                            label="ID"
                            value={this.state.vendor.vendorId}
                        />
                        <ReactTable
                            defaultPageSize={100}
                            columns={([{
                                accessor: (registration) => `${registration.lastName.slice(0, 1)}, ${registration.firstName}`,
                                Header: 'Name',
                                id: 'name'
                            }, {
                                accessor: 'textField1',
                                Header: 'Text Field One'
                            }, {
                                accessor: 'textField2',
                                Header: 'Text Field Two'
                            }])}
                            defaultSorted={[{
                                id: 'name'
                            }]}
                            data={this.state.reservations}
                        />
                    </main>
                </DocumentTitle>
            );
    }
}

export default SummaryPage;



// WEBPACK FOOTER //
// ./src/event/SummaryPage.js